module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_osharenahouse-0842e7816948c9ed874e066bd642381b.jpg";